<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>REQUISIÇÃO</span>
                        </h4>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-alert variant="warning" show v-if="mostrarAlerta"
                            ><i class="fa fa-exclamation-triangle fa-lg"></i
                            ><strong>
                                <span v-if="requisicaoIndisponivel"
                                    >Requisição indisponível para
                                    alterações.</span
                                >
                                <span v-if="!contratoVigente">
                                    Contrato não vigente.</span
                                >
                            </strong></b-alert
                        >
                        <quadro-resumo-rateios
                            :requisicao="requisicao"
                        ></quadro-resumo-rateios>
                        <div class="d-flex">
                            <app-btn-voltar
                                rota="Contratos_Requisicoes"
                            ></app-btn-voltar>
                            <btn-finalizar-requisicao
                                :requisicao="requisicao"
                                v-if="mostrarBtnFinalizar"
                                @obterRequisicaoAtualizada="obterRequisicao()"
                            ></btn-finalizar-requisicao>
                            <btn-cancelar-requisicao
                                :requisicao="requisicao"
                                v-if="mostrarBtnCancelar"
                                @obterRequisicaoAtualizada="obterRequisicao()"
                            ></btn-cancelar-requisicao>
                            <btn-devolver-solicitacao
                                :requisicao="requisicao"
                              v-if="mostrarBtnDevolverSolicitacao"
                                @obterRequisicaoAtualizada="obterRequisicao()"
                            ></btn-devolver-solicitacao>
                            <btn-devolver-requisicao
                                :requisicao="requisicao"
                                v-if="mostrarBtnDevolver"
                                @obterRequisicaoAtualizada="obterRequisicao()"
                            ></btn-devolver-requisicao>
                            <btn-enviar-requisicao
                                :requisicao="requisicao"
                                v-if="mostrarBtnEnviar"
                                @obterRequisicaoAtualizada="obterRequisicao()"
                            ></btn-enviar-requisicao>
                            <btn-selecionar-gestor-responsavel
                                :requisicao="requisicao"
                                v-if="mostrarBtnSelecionarGestor"
                                @obterRequisicao="obterRequisicao()"
                            ></btn-selecionar-gestor-responsavel>
                        </div>
                        <b-tabs class="mt-4">
                            <b-tab title="Dados Gerais" active>
                                <requisicao-detalhes
                                    :requisicao="requisicao"
                                ></requisicao-detalhes>
                                <div class="d-flex mt-4">
                                    <b-button
                                        variant="primary"
                                        @click.stop="toAtualizar()"
                                        class="ml-2"
                                        v-if="permiteAtualizar"
                                    >
                                        <i class="fa fa-edit"></i>
                                        Atualizar</b-button
                                    >
                                </div></b-tab
                            >
                            <b-tab title="Itens da Requisição"
                                ><requisicao-itens
                                    v-if="requisicao"
                                    :requisicao="requisicao"
                                    @obterRequisicaoAtualizada="
                                        obterRequisicao()
                                    "
                                    :permiteInserirItens="
                                        (!requisicaoIndisponivel &&
                                        contratoVigente &&
                                        $temAcessoView('CONT-REQ-04')) ||
                                        (requisicao && requisicao.codSituacao == 2 && requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email)
                                    "
                                    :permiteExcluirItens="
                                        (!requisicaoIndisponivel &&
                                        $temAcessoView('CONT-REQ-04')) ||
                                        (requisicao && requisicao.codSituacao == 2 && requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email)
                                    "
                                    :permiteAtualizarItens="
                                       ( !requisicaoIndisponivel &&
                                        $temAcessoView('CONT-REQ-04')) ||
                                        (requisicao && requisicao.codSituacao == 2 && requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email)
                                    "
                                    :permiteAtualizarDescontoItens="
                                        !requisicaoIndisponivel &&
                                        $temAcessoView('CONT-REQ-04')
                                    "
                                ></requisicao-itens
                            ></b-tab>
                            <b-tab title="Rateios"
                                ><requisicao-comprometimentos
                                    :contrato="requisicao.contrato"
                                    v-if="requisicao"
                                    :requisicao="requisicao"
                                    @obterRequisicaoAtualizada="
                                        obterRequisicao()
                                    "
                                    :requisicaoDisponivel="
                                        !requisicaoComprometimentoIndisponivel || ((this.requisicao.codSituacao == 2) && (this.requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email))
                                    "
                                ></requisicao-comprometimentos
                            ></b-tab>
                            <b-tab title="Histórico de análise">
                                <requisicao-analise
                                    v-if="requisicao"
                                    :requisicao="this.requisicao"
                                />
                            </b-tab>
                            <b-tab
                                title="Envios"
                                v-if="requisicao && requisicao.emailsEnvios"
                            >
                                <requisicao-envios
                                    :requisicao="requisicao"
                                ></requisicao-envios>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import RequisicaoItens from './RequisicaoItens'
import RequisicaoComprometimentos from './RequisicaoComprometimentos'
import RequisicoesServicos from './RequisicoesServicos'
import { situacaoRequisicao } from './SituacaoRequisicao'
import QuadroResumoRateios from './QuadroResumoRateios'
import BtnFinalizarRequisicao from './BtnFinalizarRequisicao'
import BtnCancelarRequisicao from './BtnCancelarRequisicao'
import BtnDevolverRequisicao from './BtnDevolverRequisicao'
import BtnEnviarRequisicao from './BtnEnviarRequisicao'
import RequisicaoEnvios from './RequisicaoEnvios'
import RequisicaoDetalhes from './RequisicaoDetalhes'
import BtnDevolverSolicitacao from './BtnDevolverSolicitacao'
import RequisicaoAnalise from './RequisicaoAnalise'
import BtnSelecionarGestorResponsavel from './BtnSelecionarGestorResponsavel'

export default {
    components: {
        QuadroResumoRateios,
        RequisicaoItens,
        RequisicaoComprometimentos,
        BtnFinalizarRequisicao,
        BtnCancelarRequisicao,
        BtnDevolverRequisicao,
        BtnEnviarRequisicao,
        RequisicaoEnvios,
        RequisicaoDetalhes,
        BtnDevolverSolicitacao,
        RequisicaoAnalise,
        BtnSelecionarGestorResponsavel
    },

    props: {},

    data() {
        return {
            size1: '160',
            erros: [],
            requisicao: null
        }
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'Contratos_Requisicoes_Atualizar',
                params: {
                    idRequisicao: this.$route.params.idRequisicao
                }
            })
        },

        obterRequisicao() {
            console.log(this.$store.getters.usuario.email)
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterPorId(
                this.$route.params.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.requisicao = response.data
                    } else {
                        this.erros = ['Erro ao obter requisição']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        permiteAtualizar() {
            if (this.requisicao) {
                return (
                    (this.$temAcessoView('CONT-REQ-03') && !this.requisicaoIndisponivel) || ((this.requisicao.codSituacao == 2) && (this.requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email))
                )
            }
            return false
        },

        requisicaoIndisponivel() {
            if (this.requisicao) {
                return (
                    !(
                        (this.requisicao.itens.length == 0 &&
                            this.requisicao.comprometimentos.length == 0) ||
                        this.requisicao.contrato.contratoVigente
                    ) ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.CONCLUIDA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.AUTORIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.FINALIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.ENVIO_REGISTRADO ||
                    this.requisicao.codSituacao == situacaoRequisicao.CANCELADA
                )
            }
            return true
        },
        requisicaoComprometimentoIndisponivel() {
            if (this.requisicao) {
                return (
                    !(
                        (this.requisicao.itens.length == 0 &&
                            this.requisicao.comprometimentos.length == 0) ||
                        this.requisicao.contrato.contratoVigente
                    ) ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.CONCLUIDA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.AUTORIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.FINALIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.ENVIO_REGISTRADO ||
                    this.requisicao.codSituacao == situacaoRequisicao.CANCELADA
                )
            }
            return true
        },

        requisicaoPodeSerDevolvida() {
            if (this.requisicao) {
                return (
                   // true
                    this.requisicao.contrato.contratoVigente &&
                    (this.requisicao.codSituacao ==
                        situacaoRequisicao.CONCLUIDA ||
                        this.requisicao.codSituacao ==
                            situacaoRequisicao.AUTORIZADA ||
                        this.requisicao.codSituacao ==
                            situacaoRequisicao.FINALIZADA ||
                        this.requisicao.codSituacao ==
                            situacaoRequisicao.ENVIO_REGISTRADO)
                )
            }
            return false
        },

        requisicaoPodeSerEnviada() {
            if (this.requisicao) {
                return (
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.CONCLUIDA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.AUTORIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.DEVOLVIDA_PARA_CORRECAO ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.DEVOLVIDA_PARA_ANALISE ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.DEVOLVIDO_FORA_DO_PRAZO ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.DEVOLVIDO_POR_FMO ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.DEVOLVIDA_INFORMACOES_INSULFICIENTES ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.CADASTRADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.ENVIO_REGISTRADO
                )
            }
            return false
        },

        mostrarBtnFinalizar() {
            if (!this.requisicao) return false
            return (
                this.$temAcessoView('CONT-REQ-07') &&
                !this.requisicaoIndisponivel &&
                this.requisicao.naoAutorizacaoEnvio
            )
        },

        mostrarBtnCancelar() {
            if (!this.requisicao) return false
            return (
                this.$temAcessoView('CONT-REQ-08') &&
                !this.requisicaoIndisponivel &&
                this.requisicao.comprometimentos.length == 0 &&
                this.requisicao.situacaoSolicitacao != 4
            )
        },

        mostrarBtnDevolver() {
            return (
                this.$temAcessoView('CONT-REQ-09') &&
                this.requisicaoPodeSerDevolvida
            )
        },

        mostrarBtnEnviar() {
            if (!this.requisicao) return false
            return (
                this.$temAcessoView('CONT-REQ-10') &&
                this.requisicaoPodeSerEnviada &&
                this.requisicao.itens.length > 0 &&
                this.requisicao.situacaoSolicitacao != 4
            )
        },
        mostrarBtnDevolverSolicitacao() {
             if (!this.requisicao) return false
             const situacaoSolicitacaoCadastrada = 0
            return (
                (this.requisicao.situacaoSolicitacao != situacaoSolicitacaoCadastrada ) 
                 
            )
        },

        mostrarBtnSelecionarGestor() {
            const situacaoSolicitacaoAguardandoAnalise = 1
            const situacaoSolicitacaoAguardandoGestor = 5
            if (!this.requisicao) return false
            return (
                this.requisicao.situacaoSolicitacao ==
                    situacaoSolicitacaoAguardandoAnalise ||
                this.requisicao.situacaoSolicitacao ==
                    situacaoSolicitacaoAguardandoGestor
            )
        },

        mostrarAlerta() {
            return this.requisicaoIndisponivel || !this.contratoVigente
        },

        contratoVigente() {
            return (
                this.requisicao &&
                this.requisicao.contrato &&
                this.requisicao.contrato.contratoVigente
            )
        }
    },

    created() {
        this.obterRequisicao()
    },

    watch: {}
}
</script>
